import { createFileRoute } from "@tanstack/react-router"
import { ContractTablePage } from "./-components/ContractTablePage"

export interface Search {
  reminderDetailOpened?: boolean
  reminderId?: number
}

export const Route = createFileRoute("/app/contracts/contracts/")({
  component: ContractTablePage,
  validateSearch: (search: Search) => ({
    ...search,
    reminderDetailOpened: search.reminderDetailOpened,
    reminderId: search.reminderId,
  }),
})
